class CtaLink extends HTMLElement {
  connectedCallback() {
    const href = this.getAttribute('href');
    const text = this.textContent.trim();

    if (!href || !text) return;

    const container = document.createElement('div');
    container.className = 'custom-blog-button-container';
    container.style.cssText = 'margin:32px 0;display:flex;flex-direction:column;align-items:center;gap:12px;min-height:clamp(40px,calc(2vw + 24px),44px)';

    const button = document.createElement('a');
    button.href = href;
    button.target = '_blank';
    button.rel = 'noopener noreferrer';
    button.textContent = text;
    button.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;text-align:center;padding:14px 32px;font-weight:600;font-size:max(clamp(12px,calc(0.347vw + 10.333px),13px),clamp(13px,calc(1.171875vw + 4px),16px));text-decoration:none;color:#FFFFFF;background-color:#fa4e70;border:1px solid #fa4e70;border-radius:5px;transition:all 0.2s ease';
    
    button.addEventListener('mouseenter', function() {
      this.style.color = '#0D0C0C';
      this.style.backgroundColor = '#FFFFFF';
      this.style.borderColor = '#fa4e70';
    });
    
    button.addEventListener('mouseleave', function() {
      this.style.color = '#FFFFFF';
      this.style.backgroundColor = '#fa4e70';
      this.style.borderColor = '#fa4e70';
    });

    container.appendChild(button);
    this.replaceWith(container);
  }
}

customElements.define('cta-link', CtaLink);

(function() {
  function convertUtmLinksToButtons() {
    const rteContainer = document.querySelector('div[id*="__main-article"] .rte, article.article .rte, .article--content');
    if (!rteContainer) return;

    const links = rteContainer.querySelectorAll('a[href*="utm"]');
    if (links.length === 0) return;

    const replacements = [];

    links.forEach(link => {
      if (link.closest('.custom-blog-button-container')) return;
      const href = link.getAttribute('href');
      if (!href) return;

      const span = link.querySelector('span');
      const text = span ? span.textContent.trim() : link.textContent.trim();
      if (!text) return;

      const ctaLink = document.createElement('cta-link');
      ctaLink.setAttribute('href', href);
      ctaLink.textContent = text;
      replacements.push({ link, ctaLink });
    });

    replacements.forEach(({ link, ctaLink }) => {
      link.parentNode.replaceChild(ctaLink, link);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', convertUtmLinksToButtons);
  } else {
    convertUtmLinksToButtons();
  }
})();
